// extracted by mini-css-extract-plugin
export default {"search":"FoodSearch_search__5clO8","searchInput":"FoodSearch_searchInput__ydzDA","searchIcon":"FoodSearch_searchIcon__zOvF5"};